import React, { useRef, useEffect, useCallback } from 'react';
import { Polygon } from '@react-google-maps/api';

const ZonePolygon = (props) => {
  const polygonRef = useRef();

  const convertToArrayPath = (polygonArray) => {
    polygonArray = polygonArray || polygonRef.polygon.getPath().getArray();
    return polygonArray.map((vertex) => ({
      lat: vertex.lat(),
      lng: vertex.lng(),
    }));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onChangePath = (e) => {
    if (e?.vertex !== undefined && e?.domEvent?.which !== 1) {
      return onRightClick(e);
    }

    const { onChange } = props;
    const { current } = polygonRef;
    if (current && current?.getPath) {
      const polygonPath = current?.getPath().getArray();
      onChange && onChange(convertToArrayPath(polygonPath));
    }
  };

  const onRightClick = (e) => {
    const { onChange, minVertexCount } = props;
    const { current } = polygonRef;

    if (e.vertex === undefined) {
      return;
    }

    let polygonPath = current.getPath();

    if (polygonPath.length > minVertexCount) {
      polygonPath.removeAt(e.vertex);
      onChange && onChange(convertToArrayPath(polygonPath.getArray()));
    }
  };
  const onLoadListener = useCallback(
    (polygon) => {
      if (polygon) {
        polygonRef.current = polygon;
      }
      const { current } = polygonRef;
      if (current && current.getPath) {
        window.google.maps.event.addListener(current?.getPath(), 'set_at', onChangePath);
        window.google.maps.event.addListener(current?.getPath(), 'insert_at', onChangePath);
      }
    },
    [onChangePath]
  );

  const removeLister = () => {
    const { current } = polygonRef;
    if (current && current?.getPath) {
      const path = current?.getPath();
      window.google.maps.event.clearListeners(path, 'set_at');
      window.google.maps.event.clearListeners(path, 'insert_at');
    }
  };

  useEffect(() => {
    onLoadListener();
    return () => {
      removeLister();
    };
  }, [onLoadListener]);

  return (
    <Polygon
      {...props}
      ref={polygonRef}
      onLoad={onLoadListener}
      onMouseUp={onChangePath}
      onRightClick={onRightClick}
    />
  );
};

ZonePolygon.defaultProps = {
  editable: false,
  visible: true,
  minVertexCount: 3,
};

export default ZonePolygon;
